import { useEffect, useState } from "react";

const KEY = "pc_view_mode";               // auto | mobile | pc
export const inFrame = () => { try { return window.self !== window.top; } catch { return true; } };

export const getViewMode = () => (inFrame() ? "auto" : localStorage.getItem(KEY) || "auto");

export const applyViewport = () => {
  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) return;
  meta.content = getViewMode() === "pc" && window.screen.width < 1024 ? "width=1280" : "width=device-width, initial-scale=1, viewport-fit=cover";
};

export const setViewMode = (m) => {
  localStorage.setItem(KEY, m);
  applyViewport();
  window.dispatchEvent(new Event("view-mode"));
};

export const useViewMode = () => {
  const [m, setM] = useState(getViewMode());
  useEffect(() => {
    const h = () => setM(getViewMode());
    window.addEventListener("view-mode", h);
    return () => window.removeEventListener("view-mode", h);
  }, []);
  return m;
};

export const useIsDesktop = () => {
  const mode = useViewMode();
  const [wide, setWide] = useState(window.innerWidth >= 1024);
  useEffect(() => {
    const h = () => setWide(window.innerWidth >= 1024);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);
  return mode === "pc" || (mode === "auto" && wide);
};

export const ViewModeSwitch = () => {
  const m = useViewMode();
  return (
    <div className="grid grid-cols-3 gap-1 rounded-xl border border-[var(--line)] p-1 text-xs font-bold" data-testid="view-mode-switch">
      {[["auto", "Auto"], ["mobile", "Mobile"], ["pc", "PC"]].map(([id, n]) => (
        <button key={id} onClick={() => setViewMode(id)} data-testid={`view-mode-${id}`}
          className={`py-2 rounded-lg transition-colors ${m === id ? "bg-[var(--cyan)] text-[#03140D]" : "text-slate-400 hover:text-slate-100"}`}>{n}</button>))}
    </div>
  );
};
